import { NextSeo } from 'next-seo'

import { getMagContent, getMagDoc, getMagTopics } from '@lib/prismic/fetch/documents'

import MagazineArticleList from '@components/magazine/MagazineArticleList'
import MagazineTopicsNav from '@components/magazine/MagazineTopicsNav'

type Props = {
	topic: string
	posts: any[]
	topicID: string
	totalPages: number
	featuredTopics: any[]
}

function MagazineTopicFilterPage({ posts, topic, topicID, totalPages, featuredTopics }: Props) {
	return (
		<>
			{/* TODO: This needs to be topic.data.title[0].text */}
			<NextSeo title={topic} />

			<MagazineTopicsNav topic={topic} featuredTopics={featuredTopics} />
			<MagazineArticleList initialPosts={posts} topicID={topicID} totalPages={totalPages} />
		</>
	)
}

export async function getStaticProps({
	params,
	previewData
}: {
	params: { uid: string }
	previewData: any
}) {
	const topic = params?.uid as string
	const topics = await getMagTopics(previewData)
	const topicID = topics.find((t) => t?.uid && t.uid === topic)?.id

	const posts = await getMagContent({ topicID, previewData })

	const magazine = await getMagDoc(previewData)
	const featuredTopics = magazine?.data?.featured_topics || []

	return {
		props: {
			posts: posts.results,
			totalPages: posts.total_pages,
			topic,
			topicID,
			featuredTopics
		}
	}
}

export async function getStaticPaths({ previewData }: { previewData: any }) {
	const topics = await getMagTopics(previewData)
	const paths = topics.reduce((arr: { params: { uid: string } }[], topic) => {
		if (topic?.uid) {
			arr.push({ params: { uid: topic.uid } })
		}

		return arr
	}, [])

	return {
		paths,
		fallback: false
	}
}

export default MagazineTopicFilterPage
